import { Button, Card, Tabs } from 'antd';
import { LanguageConsumer } from 'contexts/legacy/LanguageContext';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import { SystemConsumer } from 'contexts/legacy/SystemContext';
import React, { Component } from 'react';
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import Iframe from 'react-iframe';
import { FormattedMessage } from 'react-intl';
import video from '../../../assets/tutorials/360-dialog/video.mp4';

const { TabPane } = Tabs;

// Drag & Drop node
class TabNode extends React.Component {
	render() {
		const { connectDragSource, connectDropTarget, children } = this.props;

		return connectDragSource(connectDropTarget(children));
	}
}

const cardTarget = {
	drop(props, monitor) {
		const dragKey = monitor.getItem().index;
		const hoverKey = props.index;

		if (dragKey === hoverKey) {
			return;
		}

		props.moveTabNode(dragKey, hoverKey);
		monitor.getItem().index = hoverKey;
	},
};

const cardSource = {
	beginDrag(props) {
		return {
			id: props.id,
			index: props.index,
		};
	},
};

const WrapTabNode = DropTarget('DND_NODE', cardTarget, (connect) => ({
	connectDropTarget: connect.dropTarget(),
}))(
	DragSource('DND_NODE', cardSource, (connect, monitor) => ({
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging(),
	}))(TabNode),
);

class DraggableTabs extends React.Component {
	state = {
		order: [],
	};

	moveTabNode = (dragKey, hoverKey) => {
		const newOrder = this.state.order.slice();
		const { children } = this.props;

		React.Children.forEach(children, (c) => {
			if (newOrder.indexOf(c.key) === -1) {
				newOrder.push(c.key);
			}
		});

		const dragIndex = newOrder.indexOf(dragKey);
		const hoverIndex = newOrder.indexOf(hoverKey);

		newOrder.splice(dragIndex, 1);
		newOrder.splice(hoverIndex, 0, dragKey);

		this.setState({
			order: newOrder,
		});
	};

	renderTabBar = (props, DefaultTabBar) => (
		<DefaultTabBar {...props}>
			{(node) => (
				<WrapTabNode key={node.key} index={node.key} moveTabNode={this.moveTabNode}>
					{node}
				</WrapTabNode>
			)}
		</DefaultTabBar>
	);

	render() {
		const { order } = this.state;
		const { children } = this.props;

		const tabs = [];
		React.Children.forEach(children, (c) => {
			tabs.push(c);
		});

		const orderTabs = tabs.slice().sort((a, b) => {
			const orderA = order.indexOf(a.key);
			const orderB = order.indexOf(b.key);

			if (orderA !== -1 && orderB !== -1) {
				return orderA - orderB;
			}
			if (orderA !== -1) {
				return -1;
			}
			if (orderB !== -1) {
				return 1;
			}

			const ia = tabs.indexOf(a);
			const ib = tabs.indexOf(b);

			return ia - ib;
		});

		return (
			<DndProvider backend={HTML5Backend}>
				<Tabs renderTabBar={this.renderTabBar} {...this.props}>
					{orderTabs}
				</Tabs>
			</DndProvider>
		);
	}
}

class TutorialsView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: true,
		};
	}
	handleClickConect360 = () => {
		this.props.setActiveTabKey('1');
	};

	render() {
		return (
			<div>
				<Card
					title={<FormattedMessage id="tutorials_title" />}
					style={{ width: 'auto', margin: 5 }}
				>
					<DraggableTabs
						defaultActiveKey="8"
						activeKey={this.props.activeTabTutorialKey}
						onChange={this.props.setActiveTabTutorialKey}
					>
						{/* AJUDA BOAS PRÁTICAS */}
						<TabPane tab={<FormattedMessage id="help_good_habits" />} key={8}>
							<FormattedMessage
								id="help_good_habits_title"
								values={{
									b: (chunk) => (
										<h2>
											<b>{chunk}</b>
										</h2>
									),
								}}
							/>
							<br />
							<FormattedMessage id="help_good_habits_intro" />
							<br /> <br />
							<FormattedMessage id="help_good_habits_1" />
							<br />
							<FormattedMessage id="help_good_habits_2" />
							<br />
							<FormattedMessage id="help_good_habits_3" />
							<br />
							<FormattedMessage id="help_good_habits_4" />
							<br />
							<FormattedMessage id="help_good_habits_5" />
							<br />
							<FormattedMessage id="help_good_habits_6" />
							<br />
							<FormattedMessage id="help_good_habits_7" />
							<br />
							<FormattedMessage id="help_good_habits_8" />
							<br />
							<FormattedMessage id="help_good_habits_9" />
							<br />
							<FormattedMessage id="help_good_habits_10" />
							<br />
							<FormattedMessage id="help_good_habits_11" />
							<br />
							<FormattedMessage id="help_good_habits_12" />
							<br /> <br />
							<FormattedMessage
								id="help_ban_title"
								values={{
									b: (chunk) => (
										<h2>
											<b>{chunk}</b>
										</h2>
									),
								}}
							/>
							<br />
							<FormattedMessage id="help_ban_intro_1" />
							<br />
							<br />
							<FormattedMessage id="help_ban_intro_2" />
							<br />
							<br />-{' '}
							<a href="https://www.whatsapp.com/contact/?subject=messenger" target="blank">
								<FormattedMessage id="help_link" />
							</a>
							<br />
							<FormattedMessage
								id="help_email"
								values={{
									email1: (
										<a href="smb@support.whatsapp.com" target="blank">
											smb@support.whatsapp.com
										</a>
									),
									email2: (
										<a href="supporte@supporte.whatsapp.com" target="blank">
											supporte@supporte.whatsapp.com
										</a>
									),
								}}
							/>
							<br />
							<br />
							<FormattedMessage
								id="help_ban_intro_3"
								values={{
									b: (chunk) => (
										<h3>
											<b>{chunk}</b>
										</h3>
									),
								}}
							/>
							<br />
							<FormattedMessage
								id="help_ban_item_1"
								values={{
									link: (
										<a href="https://www.whatsapp.com/contact/?subject=messenger" target="blank">
											<FormattedMessage id="help_ban_link" />
										</a>
									),
								}}
							/>
							<br />
							<FormattedMessage id="help_ban_item_2" />
							<br />
							<br />
							<img src={require(`assets/tutorials/ban/img_ban.png`)} alt="ban" />
							<br />
							<br />
							<FormattedMessage id="help_ban_item_3" />
							<br />
							<br />
							<FormattedMessage id="help_ban_item_3_1" />
							<br />
							<br />
							<FormattedMessage id="help_ban_item_3_2" />
							<br />
							<br />
							<FormattedMessage id="help_ban_item_3_3" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br />
							<br />
							<FormattedMessage id="help_ban_item_4" />
							<br />
							<br />
							<FormattedMessage id="help_ban_item_4_1" />
							<br />
							<br />
							<FormattedMessage
								id="help_ban_item_4_2"
								values={{
									b: (chunk) => (
										<h3>
											<b>{chunk}</b>
										</h3>
									),
								}}
							/>
							<br />
							<FormattedMessage
								id="help_ban_item_4_3"
								values={{
									email1: (
										<a href="smb@support.whatsapp.com" target="blank">
											smb@support.whatsapp.com
										</a>
									),
									email2: (
										<a href="supporte@supporte.whatsapp.com" target="blank">
											supporte@supporte.whatsapp.com
										</a>
									),
								}}
							/>
							<br />
							<br />
							<FormattedMessage id="help_ban_item_4_4" />
							<br />
							<br />
							<FormattedMessage id="help_ban_item_4_5" />
							<br />
							<br />
							<FormattedMessage id="help_ban_item_3_3" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br />
							<br />
							<FormattedMessage id="help_ban_conn" />
							<br />
							<br />
							<FormattedMessage id="help_ban_conn_1" />
							<br />
							<FormattedMessage id="help_ban_conn_2" />
							<br />
							<FormattedMessage id="help_ban_conn_3" />
							<br />
							<FormattedMessage id="help_ban_conn_4" />
							<br />
							<FormattedMessage id="help_ban_conn_5" />
							<br />
							<FormattedMessage id="help_ban_conn_6" />
							<br />
							<FormattedMessage id="help_ban_conn_7" />
							<br />
							<br />
							<a
								href="http://ajuda.br24.io/?utm_source=powerzap&utm_medium=boas-praticas&utm_campaign=banimento"
								target="blank"
							>
								<b>
									<FormattedMessage id="help_ban_info" />
								</b>
							</a>
						</TabPane>

						{/* AJUDA WIDGETS */}
						<TabPane tab={<FormattedMessage id="help_widget" />} key={9}>
							<FormattedMessage
								id="help_widget_title"
								values={{
									b: (chunk) => (
										<h2>
											<b>{chunk}</b>
										</h2>
									),
								}}
							/>
							<br />
							<FormattedMessage id="help_widget_intro" />
							<br /> <br />
							<FormattedMessage
								id="help_widget_1"
								values={{
									link: (
										<a href={process.env.REACT_APP_WIDGET_BUILDER_URL} target="blank">
											<FormattedMessage id="help_widget_link_text" />
										</a>
									),
								}}
							/>
							<br />
							<FormattedMessage id="help_widget_2" />
							<br />
							{this.props.language.lang === 'br' && (
								<img
									src={require(`assets/tutorials/widget/tela_1_br.png`)}
									alt="automation"
									style={{ width: '60vw' }}
								/>
							)}
							{this.props.language.lang === 'en' && (
								<img
									src={require(`assets/tutorials/widget/tela_1_en.png`)}
									alt="automation"
									style={{ width: '60vw' }}
								/>
							)}
							{this.props.language.lang === 'la' && (
								<img
									src={require(`assets/tutorials/widget/tela_1_la.png`)}
									alt="automation"
									style={{ width: '60vw' }}
								/>
							)}
							<br />
							<br />
							<FormattedMessage id="help_widget_3" />
							<br />
							{this.props.language.lang === 'br' && (
								<img
									src={require(`assets/tutorials/widget/tela_2_br.png`)}
									alt="automation"
									style={{ width: '60vw' }}
								/>
							)}
							{this.props.language.lang === 'en' && (
								<img
									src={require(`assets/tutorials/widget/tela_2_en.png`)}
									alt="automation"
									style={{ width: '60vw' }}
								/>
							)}
							{this.props.language.lang === 'la' && (
								<img
									src={require(`assets/tutorials/widget/tela_2_la.png`)}
									alt="automation"
									style={{ width: '60vw' }}
								/>
							)}
							<br />
							<br />
							<FormattedMessage
								id="help_widget_4"
								values={{
									b: (chunk) => (
										<h4>
											<b>{chunk}</b>
										</h4>
									),
								}}
							/>
							<br />
							<div style={{ width: '60vw' }}>
								<Iframe
									src="https://drive.google.com/file/d/1Ll4d8kx4pt_ACRn4LRSY2mL9757yXN0P/preview"
									width="100%"
									height="480px"
									frameBorder="0"
									allow="autoplay"
									allowFullScreen
								/>
							</div>
							<br />
							<br />
							<FormattedMessage
								id="help_widget_5"
								values={{
									b: (chunk) => (
										<h4>
											<b>{chunk}</b>
										</h4>
									),
								}}
							/>
							<br />
							<div style={{ width: '60vw' }}>
								<Iframe
									src="https://drive.google.com/file/d/18F62guEtpqpX2YWLkXpFgt8WDMaqauvn/preview"
									width="100%"
									height="480px"
									frameBorder="0"
									allow="autoplay"
									allowFullScreen
								/>
							</div>
							<br />
							<br />
							<FormattedMessage
								id="help_widget_6"
								values={{
									b: (chunk) => (
										<h4>
											<b>{chunk}</b>
										</h4>
									),
								}}
							/>
							<br />
							<div style={{ width: '60vw' }}>
								<Iframe
									src="https://drive.google.com/file/d/1GBV1FndSnnAeg82affsUJsz49CEf-oxd/preview"
									width="100%"
									height="480px"
									frameBorder="0"
									allow="autoplay"
									allowFullScreen
								/>
							</div>
							<br />
							<br />
						</TabPane>

						{/* AJUDA PERMISSÕES */}
						<TabPane tab={<FormattedMessage id="permissions" />} key={7}>
							<FormattedMessage id="permissions_introduction" />
							<br /> <br />
							<FormattedMessage
								id="permissions_introduction_1"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br />
							<FormattedMessage
								id="permissions_introduction_2"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br />
							<FormattedMessage
								id="permissions_introduction_3"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br />
							<FormattedMessage
								id="permissions_introduction_4"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_introduction_5" />
							<br /> <br />
							<FormattedMessage
								id="permissions_introduction_6"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_introduction_7" />
							<br /> <br />
							<FormattedMessage id="permissions_introduction_8" />
							<br />
							<FormattedMessage id="permissions_introduction_9" />
							<br />
							<FormattedMessage id="permissions_introduction_10" />
							<br /> <br />
							<FormattedMessage id="permissions_introduction_11" />
							<br /> <br />
							<FormattedMessage id="permissions_tutorial" />
							<br /> <br />
							<FormattedMessage
								id="permissions_tutorial_1"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-1.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage
								id="permissions_tutorial_2"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_3" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-2.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_4" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-3.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_5" />
							<br /> <br />
							<FormattedMessage
								id="permissions_tutorial_6"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-4.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage
								id="permissions_tutorial_7"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-5.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage
								id="permissions_tutorial_8"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-6.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_9" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-7.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_10" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-8.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_11" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-9.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_12" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-10.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<img
								src={require(`assets/tutorials/permissions/permissions-11.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage
								id="permissions_tutorial_13"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_14" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-12.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_15" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-13.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_16" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-14.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_17" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-15.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_18" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-16.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<img
								src={require(`assets/tutorials/permissions/permissions-17.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage
								id="permissions_tutorial_19"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_20" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-18.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_21" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-19.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_22" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-20.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_23" />
							<br />
							<img
								src={require(`assets/tutorials/permissions/permissions-21.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<img
								src={require(`assets/tutorials/permissions/permissions-22.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="permissions_tutorial_24" />
							<br />
						</TabPane>

						{/* AJUDA CAMPANHA DE MARKETING */}
						<TabPane tab={<FormattedMessage id="help_campaign_title" />} key={5}>
							<FormattedMessage id="help_campaign_1" />
							<br /> <br />
							<FormattedMessage id="help_campaign_2" />
							<br /> <br />
							<img
								src={require(`assets/tutorials/campaign/tela_1.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br /> <br />
							<FormattedMessage id="help_campaign_3" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<img
								src={require(`assets/tutorials/campaign/tela_2.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage id="help_campaign_4" />
							<br /> <br />
							<img
								src={require(`assets/tutorials/campaign/tela_3.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br />
							<br />
							<FormattedMessage id="help_campaign_10" />
							<br /> <br />
							<img
								src={require(`assets/tutorials/campaign/tela_4.jpeg`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br />
							<br />
							<FormattedMessage id="help_campaign_11" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<img
								src={require(`assets/tutorials/campaign/tela_5.jpeg`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br />
							<br />
							<FormattedMessage id="help_campaign_12" />
							<br /> <br />
							<img
								src={require(`assets/tutorials/campaign/tela_6.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br />
							<br />
							<FormattedMessage id="help_campaign_5" />
							<br />
							<br />
							<div style={{ width: '100vw', display: 'flex' }}>
								<Iframe
									src="https://www.youtube.com/embed/On1XkNmU41w"
									width="1370px"
									height="770px"
									frameBorder="0"
									id="video"
									allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
									allowFullScreen
									styles={{ margin: 'auto' }}
								/>
							</div>
							<br /> <br />
							<FormattedMessage id="help_campaign_6" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<FormattedMessage id="help_campaign_7" />
							<br /> <br />
							<FormattedMessage id="help_campaign_8" />
							<br /> <br />
							<FormattedMessage id="help_campaign_9" />
							<br /> <br />
						</TabPane>

						{/* AJUDA 360 DIALOG */}
						<TabPane tab={<FormattedMessage id="help_360_dialog_1" />} key={3}>
							<h2>
								<FormattedMessage id="help_360_dialog_2" />
							</h2>
							<br />
							<FormattedMessage id="help_360_dialog_3" />
							<br /> <br />
							<video width="100%" controls>
								<source src={video} type="video/mp4" />
								<FormattedMessage id="help_360_dialog_4" />
							</video>
							<br /> <br /> <br />
							<h2>
								<FormattedMessage id="help_360_dialog_45" />
							</h2>
							<br />
							<FormattedMessage id="help_360_dialog_46" />
							<a href="https://www.360dialog.com/contact" target="_blank">
								<FormattedMessage id="help_360_dialog_47" />
							</a>
							<FormattedMessage id="help_360_dialog_48" />
							<br /> <br /> <br />
							<h2>
								<FormattedMessage id="help_360_dialog_5" />
							</h2>
							<br />
							<a href="https://docs.360dialog.com/docs/client-hub/partner-change" target="_blank">
								<FormattedMessage id="help_360_dialog_6" />
							</a>
							<FormattedMessage
								id="help_360_dialog_7"
								values={{ partner: process.env.REACT_APP_DIALOG_PARTNER_ID }}
							/>
							<br /> <br /> <br />
							<h2>
								<FormattedMessage id="help_360_dialog_8" />
							</h2>
							<h3>
								<FormattedMessage id="help_360_dialog_9" />
							</h3>
							<br />
							<FormattedMessage id="help_360_dialog_10" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_1.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_11" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_2.png`)} alt="360 Dialog" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_3.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_12" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_13" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_14" />
							<a
								href="https://docs.360dialog.com/docs/360dialog/prices-plans-and-payment-options"
								target="_blank"
							>
								<FormattedMessage id="help_360_dialog_15" />
							</a>
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_4.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_16" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_17" />
							<br /> <br />
							<span id="numberWhatsappApi">
								<b>
									<FormattedMessage id="help_360_dialog_18" />
								</b>
							</span>
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_5.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_19" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_6.png`)} alt="360 Dialog" />
							<br /> <br />
							<span id="numberMetaAccount">
								<FormattedMessage id="help_360_dialog_20" />
							</span>
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_7.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_21" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_8.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_22" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_9.png`)} alt="360 Dialog" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_10.png`)} alt="360 Dialog" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_11.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_23" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_12.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_24" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_13.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_25" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_14.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_26" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_15.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_27" />
							<a
								href="https://docs.360dialog.com/docs/client-hub/template-management-ui"
								target="_blank"
							>
								<FormattedMessage id="help_360_dialog_28" />
							</a>
							<br /> <br />
							<Button
								class="ant-btn ant-btn-primary"
								style={{ background: '#1890FF', color: 'white' }}
							>
								<a href="#" onClick={this.handleClickConect360}>
									<FormattedMessage id="help_360_dialog_52" />
								</a>
							</Button>
							<br /> <br />
							<b>
								<FormattedMessage id="help_360_dialog_29" />
							</b>
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_16.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_30" />
							<a
								href="https://faq.whatsapp.com/2138577903196467/?cms_platform=android"
								target="_blank"
							>
								<FormattedMessage id="help_360_dialog_31" />
							</a>
							<FormattedMessage id="help_360_dialog_32" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_33" />
							<br /> <br />
							<b>
								<FormattedMessage id="help_360_dialog_34" />
							</b>
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_17.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_35" />
							<a href="#numberMetaAccount">
								<FormattedMessage id="help_360_dialog_36" />
							</a>
							<br /> <br />
							<FormattedMessage id="help_360_dialog_37" />
							<a href="#numberWhatsappApi">
								<FormattedMessage id="help_360_dialog_38" />
							</a>
							<br /> <br />
							<b>
								<FormattedMessage id="help_360_dialog_39" />
							</b>
							<br /> <br />
							<FormattedMessage id="help_360_dialog_40" />
							<a
								href="https://docs.360dialog.com/docs/waba-messaging/conversations"
								target="_blank"
							>
								<FormattedMessage id="help_360_dialog_41" />
							</a>
							<br /> <br />
							<FormattedMessage id="help_360_dialog_42" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_43" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_18.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_44" />
							<br /> <br />
							<img src={require(`assets/tutorials/360-dialog/tela_19.png`)} alt="360 Dialog" />
							<br /> <br />
							<FormattedMessage id="help_360_dialog_53" />
							<br /> <br />
							<ol>
								<li>
									<FormattedMessage id="help_360_dialog_54" />
									<br />
									<FormattedMessage id="help_360_dialog_55" />
									<br /> <br />
									<img
										src={require(`assets/tutorials/360-dialog/tela_20.png`)}
										alt="360 Dialog"
										style={{ width: '80vw' }}
									/>
									<br /> <br />
								</li>
								<li>
									<FormattedMessage id="help_360_dialog_56" />
									<br />
									<FormattedMessage id="help_360_dialog_57" />
									<br />
									<FormattedMessage id="help_360_dialog_58" />
									<br />
									<FormattedMessage id="help_360_dialog_59" />
									<br /> <br />
									<img
										src={require(`assets/tutorials/360-dialog/tela_21.png`)}
										alt="360 Dialog"
										style={{ width: '60vw' }}
									/>
									<br /> <br />
								</li>
								<li>
									<FormattedMessage id="help_360_dialog_60" />
									<br />
									<FormattedMessage id="help_360_dialog_61" />
									<br />
									<FormattedMessage id="help_360_dialog_62" />
									<br />
									<FormattedMessage id="help_360_dialog_63" />
									<br /> <br />
									<img
										src={require(`assets/tutorials/360-dialog/tela_22.png`)}
										alt="360 Dialog"
										style={{ width: '60vw' }}
									/>
									<br /> <br />
									<img
										src={require(`assets/tutorials/360-dialog/tela_23.png`)}
										alt="360 Dialog"
										style={{ width: '60vw' }}
									/>
									<br /> <br />
									<img
										src={require(`assets/tutorials/360-dialog/tela_24.png`)}
										alt="360 Dialog"
										style={{ width: '60vw' }}
									/>
									<br /> <br />
								</li>
								<li>
									<FormattedMessage id="help_360_dialog_64" />
									<br />
									<FormattedMessage id="help_360_dialog_65" />
									<br />
									<FormattedMessage id="help_360_dialog_66" />
									<br /> <br />
									<img
										src={require(`assets/tutorials/360-dialog/tela_25.png`)}
										alt="360 Dialog"
										style={{ width: '60vw' }}
									/>
									<br /> <br />
								</li>
								<li>
									<FormattedMessage id="help_360_dialog_67" />
									<br />
									<FormattedMessage id="help_360_dialog_68" />
									<br />
									<FormattedMessage id="help_360_dialog_69" />
									<br />
									<FormattedMessage id="help_360_dialog_70" />
								</li>
							</ol>
							<br /> <br />
							<h2>
								<FormattedMessage id="help_360_dialog_50" />
							</h2>
							<br />
							<FormattedMessage id="help_360_dialog_51" />
							<a href="https://www.360dialog.com/contact" target="_blank">
								<FormattedMessage id="help_360_dialog_47" />
							</a>
							<FormattedMessage id="help_360_dialog_48" />
						</TabPane>

						{/* AJUDA MESSAGEBIRD */}
						<TabPane tab={<FormattedMessage id="help_MessageBird_title" />} key={2}>
							<FormattedMessage id="help_MessageBird_1" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_2" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_1.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_3" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_2.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_4" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_3.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_5" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_4.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_6" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_5.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_7" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_8" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_9" />
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_6.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage
								id="help_MessageBird_10"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_7.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_11" />
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_8.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage
								id="help_MessageBird_12"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_9.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_13" />
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_10.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_14" />
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_11.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage
								id="help_MessageBird_15"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_12.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_16" />
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_13.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_17" />
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_14.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_18" />
							<br /> <br />
							<img src={require(`assets/tutorials/message-bird/tela_15.png`)} alt="MessageBird" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_19" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_20" />
							<br /> <br />
							<FormattedMessage id="help_MessageBird_21" />
							<br /> <br />
						</TabPane>

						{/* AJUDA AUTOMAÇÃO */}
						<TabPane tab={<FormattedMessage id="help_automation_title" />} key={4}>
							<FormattedMessage id="help_automation_1" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_1.png`)} alt="automation" />
							<br /> <br /> <br />
							<FormattedMessage id="help_automation_2" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_2.png`)} alt="automation" />
							<br /> <br /> <br />
							<FormattedMessage id="help_automation_3" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_3.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_4" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_4.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_5" />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_5.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_6" />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_6.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_7" />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_7.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_8" />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_8.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_9" />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_9.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_10" />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_10.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_19" />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_16.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_20" />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_17.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_21" />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_18.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_11" />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_11.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_12" />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_12.png`)} alt="automation" />
							<br /> <br />
							<img src={require(`assets/tutorials/automation/tela_13.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_13" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br /> <br />
							<FormattedMessage id="help_automation_14" />
							<br />
							<br />
							<FormattedMessage id="help_automation_15" />
							<br />
							<FormattedMessage id="help_automation_16" />
							<br />
							<br />
							<img src={require(`assets/tutorials/automation/tela_14.png`)} alt="automation" />
							<br /> <br />
							<FormattedMessage id="help_automation_17" />
							<br />
							<br />
							<img src={require(`assets/tutorials/automation/tela_15.png`)} alt="automation" />
							<br />
							<br />
							<FormattedMessage id="help_automation_22" values={{ b: (chunk) => <b>{chunk}</b> }} />
							<br />
							<br />
							<FormattedMessage id="help_automation_23" />
							<br />
							<FormattedMessage id="help_automation_24" />
							<br />
							<br />
							<img
								src={require(`assets/tutorials/automation/tela_19.png`)}
								width={1200}
								alt="automation"
							/>
							<br />
							<br />
							<FormattedMessage id="help_automation_25" />
							<br />
							<br />
							<img src={require(`assets/tutorials/automation/tela_20.png`)} alt="automation" />
							<br />
							<br />
							<FormattedMessage id="help_automation_26" />
							<br />
							<br />
							<img
								src={require(`assets/tutorials/automation/tela_21.jpeg`)}
								width={400}
								alt="automation"
							/>
						</TabPane>

						{/* AJUDA ENVIO DE ARQUIVOS */}
						<TabPane tab={<FormattedMessage id="supported_files_title" />} key={6}>
							<FormattedMessage
								id="help_maximum_file_size_1"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br /> <br />
							<FormattedMessage id="help_maximum_file_size_2" />
							<br /> <br />
							<FormattedMessage
								id="help_maximum_file_size_3"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br />
							<FormattedMessage
								id="help_maximum_file_size_4"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>
							<br />
							<img
								src={require(`assets/tutorials/file-limit/tela_1.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage
								id="help_maximum_file_size_5"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>{' '}
							<br />
							<img
								src={require(`assets/tutorials/file-limit/tela_2.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
							<FormattedMessage
								id="help_maximum_file_size_6"
								values={{ b: (chunk) => <b>{chunk}</b> }}
							/>{' '}
							<br />
							<img
								src={require(`assets/tutorials/file-limit/tela_3.png`)}
								alt="automation"
								style={{ width: '80vw' }}
							/>
							<br /> <br />
						</TabPane>
						<TabPane tab={<FormattedMessage id="help_button_title" />} key={10}>
							<h1>
								<FormattedMessage id="help_button_0" />
							</h1>
							<FormattedMessage id="help_button_1" />
							<br /> <br />
							<FormattedMessage id="help_button_2" />
							<br /> <br />
							<FormattedMessage id="help_button_3" />
							<br /> <br />
							<video
								width="80%"
								controls
								style={{ marginBottom: '20px' }}
								src={require(`assets/tutorials/button/Feature BotõesCard.mp4`)}
								alt="button"
							/>
							<br /> <br />
							<FormattedMessage id="help_button_4" />
							<br /> <br />
							<video
								width="80%"
								controls
								style={{ marginBottom: '20px' }}
								src={require(`assets/tutorials/button/Feature Botões Contact center.mp4`)}
								alt="button"
							/>
							<br /> <br />
							<FormattedMessage id="help_button_5" />
							<br /> <br />
							<video
								width="80%"
								controls
								style={{ marginBottom: '20px' }}
								src={require(`assets/tutorials/button/Feature Botões Automação.mp4`)}
								alt="button"
							/>
							<br /> <br />
							<FormattedMessage id="help_button_6" />
							<br /> <br />
							<FormattedMessage id="help_button_7" />
							<br /> <br />
						</TabPane>

						<TabPane tab={<FormattedMessage id="help_audio_transcription_title" />} key={11}>
							<div style={{ padding: '16px' }}>
								<h2>
									<FormattedMessage id="help_audio_transcription_0" />
								</h2>
								<p>
									<FormattedMessage id="help_audio_transcription_1" />
								</p>

								<h3>
									<FormattedMessage id="help_audio_transcription_2" />
								</h3>
								<ul>
									<li>
										<FormattedMessage id="help_audio_transcription_3" />
									</li>
									<li>
										<FormattedMessage id="help_audio_transcription_4" />
									</li>
								</ul>

								<h3>
									<FormattedMessage id="help_audio_transcription_22" />
								</h3>
								<ul>
									<li>audio/mp3</li>
									<li>audio/mpeg</li>
									<li>audio/ogg</li>
									<li>audio/opus</li>
									<li>audio/wav</li>
									<li>audio/aac</li>
									<li>audio/x-wav</li>
									<li>audio/webm</li>
									<li>audio/mp4</li>
									<li>audio/x-m4a</li>
								</ul>

								<h3>
									<FormattedMessage id="help_audio_transcription_5" />
								</h3>
								<ol>
									<li>
										<FormattedMessage id="help_audio_transcription_6" />
										<ul>
											<li>
												<FormattedMessage id="help_audio_transcription_7" />
											</li>
										</ul>
										<div style={{ display: 'flex', gap: '16px', marginTop: '12px' }}>
											<img
												src={require(`assets/tutorials/audio-transcription/tela_1.png`)}
												alt="transcription"
												style={{ width: '48%', height: '48%' }}
											/>
											<img
												src={require(`assets/tutorials/audio-transcription/tela_2.png`)}
												alt="transcription"
												style={{ width: '48%', height: '48%' }}
											/>
										</div>
									</li>
									<li>
										<FormattedMessage id="help_audio_transcription_8" />
										<ul>
											<li>
												<FormattedMessage id="help_audio_transcription_9" />
											</li>
											<li>
												<FormattedMessage id="help_audio_transcription_10" />
											</li>

											<div style={{ display: 'flex', gap: '16px', marginTop: '12px' }}>
												<img
													src={require(`assets/tutorials/audio-transcription/tela_3.png`)}
													alt="transcription"
													style={{ width: '48%', height: '48%' }}
												/>
											</div>
										</ul>
									</li>
									<li>
										<FormattedMessage id="help_audio_transcription_11" />
										<ul>
											<li>
												<FormattedMessage id="help_audio_transcription_12" />
											</li>
											<li>
												<FormattedMessage id="help_audio_transcription_13" />
											</li>

											<div style={{ display: 'flex', gap: '16px', marginTop: '12px' }}>
												<img
													src={require(`assets/tutorials/audio-transcription/tela_4.png`)}
													alt="transcription"
													style={{ width: '48%', height: '48%' }}
												/>
											</div>
										</ul>
									</li>
									<li>
										<FormattedMessage id="help_audio_transcription_14" />

										<div style={{ display: 'flex', gap: '16px', marginTop: '12px' }}>
											<img
												src={require(`assets/tutorials/audio-transcription/tela_5.png`)}
												alt="transcription"
												style={{ width: '48%', height: '48%' }}
											/>
										</div>
									</li>
								</ol>

								<p>
									<FormattedMessage id="help_audio_transcription_15" />
								</p>

								<h3>
									<FormattedMessage id="help_audio_transcription_16" />
								</h3>
								<ul>
									<li>
										<FormattedMessage id="help_audio_transcription_17" />
									</li>
									<li>
										<FormattedMessage id="help_audio_transcription_18" />
									</li>
								</ul>

								<h3>
									<FormattedMessage id="help_audio_transcription_19" />
								</h3>
								<ul>
									<li>
										<FormattedMessage id="help_audio_transcription_20" />
									</li>
									<li>
										<FormattedMessage id="help_audio_transcription_21" />
									</li>
								</ul>
							</div>
						</TabPane>
					</DraggableTabs>
				</Card>
			</div>
		);
	}
}

export default LanguageConsumer(NumberConsumer(SystemConsumer(TutorialsView)));
